import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../angular-material.module';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { LetDirective } from 'src/app/core/utils/let-directive';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TAIGA_UI_MODULES } from 'src/app/shared/taiga.module';
import { DocTypesStoreModule } from '../doc-types/store/module';
import { WorkspacesComponent } from './components/workspaces/workspaces.component';
import { WorkspacesListComponent } from './components/workspaces-list/workspaces-list.component';
import { WorkspacesRoutingModule } from './workspaces-routing.module';
import { WorkspacesStoreModule } from './store/module';
import { AddWorkspaceModalComponent } from './components/modals/add-workspace-modal/add-workspace-modal.component';
import { RenameWorkspaceModalComponent } from './components/modals/rename-workspace-modal/rename-workspace-modal.component';
import { WorkspaceDetailsComponent } from './components/workspace-details/workspace-details.component';
import { WorkspaceDocumentsComponent } from './components/workspace-documents/workspace-documents.component';
import { ClauseVarianceAnalysisBoxComponent } from './components/clause-variance-analysis-box/clause-variance-analysis-box.component';
import { ClauseVarianceAnalysisComponent } from './components/clause-variance-analysis/clause-variance-analysis.component';
import { AnalyzingClauseVarianceProgressbarComponent } from './components/clause-variance-analysis/components/analyzing-clause-variance-progress-bar/analyzing-clause-variance-progress-bar.component';
import { AnalyzingClauseVarianceDashboardComponent } from './components/clause-variance-analysis/components/analyzing-clause-variance-dashboard/analyzing-clause-variance-dashboard.component';
import { AddWorkspaceDocumentsModalComponent } from './components/modals/add-workspace-documents-modal/add-workspace-documents-modal.component';
import { AnalyzingClauseAlignmentMatrixComponent } from './components/clause-variance-analysis/components/analyzing-clause-alignment-matrix/analyzing-clause-alignment-matrix.component';
import { AnalyzingClauseAlignmentDetailedComponent } from './components/clause-variance-analysis/components/analyzing-clause-alignment-detailed/analyzing-clause-alignment-detailed.component';

@NgModule({
  declarations: [
    WorkspacesComponent,
    WorkspacesListComponent,
    AddWorkspaceModalComponent,
    AddWorkspaceDocumentsModalComponent,
    RenameWorkspaceModalComponent,
    WorkspaceDetailsComponent,
    WorkspaceDocumentsComponent,
    ClauseVarianceAnalysisBoxComponent,
    ClauseVarianceAnalysisComponent,
    AnalyzingClauseVarianceProgressbarComponent,
    AnalyzingClauseVarianceDashboardComponent,
    AnalyzingClauseAlignmentMatrixComponent,
    AnalyzingClauseAlignmentDetailedComponent,
  ],
  imports: [
    WorkspacesRoutingModule,
    DocTypesStoreModule,
    SharedModule,
    ReactiveFormsModule,
    CommonModule,
    AngularMaterialModule,
    MatIconModule,
    TranslocoModule,
    PipesModule,
    WorkspacesStoreModule,
    LetDirective,
    NgxFileDropModule,
    SplitButtonModule,
    TAIGA_UI_MODULES,
  ],
})
export class WorkspacesModule {}
